export default {
  FRIEND_AND_GAME_INVITE: 1,
  DAILY_BONUS: 2,
  LOTTERY_BONUS: 3,
  WEEKLY_BONUS: 4,
  FOUR_HOURLY_BONUS: 5,
};
